<template>
    <div>
        <el-select class="language" @change="setLanguage" :value="selectedLanguage" value-key="value" placeholder="Select">
          <template slot="prefix"><img class="prefix" :src="photo" /></template>
          <el-option v-for="item in language" :key="item.value" :label="item.value" :value="item">
            <img :src="photo"> {{ item.value }}
          </el-option>
        </el-select>
    </div>
</template>

<script>
  export default {
    data () {
      return {
        language: [{
          value: 'EN'
        }, {
          value: 'ES'
        },
        {
          value: 'ZH'
        }],
        photo: 'static/lang.png'
      }
    },
    computed: {
      selectedLanguage () {
        const html = document.documentElement
        html.setAttribute('lang', this.$store.state.lang.value.toLowerCase())
        return this.$store.state.lang.value
      }
    },
    methods: {
      setLanguage (type) {
        this.$store.commit('setLang', type)
      }
    }
  }
</script>

<style lang="css" scoped>
  .language{
    width: 80px;
  }

  .prefix {
    margin-top: 10px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  >>> .el-input__inner{
    border-radius: 20px;
  }
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/LanguageButton.vue